import React from 'react';
import { connect } from 'react-redux';
import { toggleHeaderMenu } from '../../actions/uiActions';
import { getCurrentLangCode } from '../../reducers/i18n';

import { getPageTitle } from '../../reducers/title';
import { getDrawerState } from '../../reducers/ui.header';
import Drawer from './Drawer';
import HeaderBase from './HeaderBase';
import HeaderToolbar from './HeaderToolbar';
import Search from './ExpandableSiteSearch';
import MainMenu from './MainMenuDrawer';
import Navigation from './Navigation';

const Header = ({ title, page, toggleHeaderMenu, open, lang }) => {
    const handleClose = () => toggleHeaderMenu();

    return (
        <React.Fragment>
            <HeaderBase
                Toolbar={HeaderToolbar}
                toggleMenu={handleClose}
                title={title}
                page={page}
                open={open}
                offset={30}
                Search={Search}
                Navigation={Navigation}
                Drawer={<Drawer
                    toggleMenu={handleClose}
                    open={open}
                    Menu={<MainMenu lang={lang} />}
                />}
            />
        </React.Fragment>
    );
};

const makeMapStateToProps = initialState => {
    const { page } = initialState;
    const title = getPageTitle(initialState);
    const lang = getCurrentLangCode(initialState);
    return state => (
        {
            page,
            title,
            open: getDrawerState(state),
            lang,
        }
    );
};

const MapDispatchToProps = dispatch => (
    { toggleHeaderMenu: () => dispatch(toggleHeaderMenu()) }
);

export default connect(makeMapStateToProps, MapDispatchToProps)(Header);



// WEBPACK FOOTER //
// ./src/components/header/PatternCategories.js